$(document).ready(function () {


  if ($('.product__media-list li').length === 1) {
    $(".product__media-list")
      .removeClass("product__media-list-grid")
      .addClass("product__media-list-list");
    $(".gallery_switcher").hide();
    return false;
  }

  $(".gallery_switcher ul li:nth-child(2) a").addClass("active");

});

$(".gallery_switcher ul li a").on("click", function (e) {
  $(".product__media-list")
    .removeClass("product__media-list-list")
    .removeClass("product__media-list-grid");
  e.preventDefault();
  $(".gallery_switcher ul li a").removeClass("active");
  $(this).addClass("active");
  let type = $(this).attr('href');
  $(".product__media-list").addClass(
    "product__media-list-" + type.replace("#", "")
  );
  $(".masonry-grid").masonry({
    itemSelector: ".masonry-grid__item",
    horizontalOrder: true,
  });
  return false;
});

function recommendationsSlider() {
  if ($(window).width() > 750) {
    /* related products slider */
    setTimeout(function () {
      if ($("product-recommendations .product-grid li").length > 1) {
      $("product-recommendations .product-grid").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: false,
        prevArrow:
          '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
        nextArrow:
          '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
      });
      }
    }, 0);
  }
}


function mobileProductSlider() {
  if ($(window).width() < 750) {
    $(".slider--mobile").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      prevArrow:
        '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
      nextArrow:
        '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--15600283320497__16545148190446716e"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
    });
    
  }
}
mobileProductSlider();


$(document).ready(function () {

  if ($(".masonry-grid").length > 0 && $(window).width() > 750) {
    $(".masonry-grid").masonry({
      itemSelector: ".masonry-grid__item",
      horizontalOrder: true,
    });
  }
});

$(window).resize(function () {
  if ($(".masonry-grid").length > 0 && $(window).width() > 750) {
    $(".masonry-grid").masonry({
      itemSelector: ".masonry-grid__item",
    });
  }
});
